import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c5ceae8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5ceae8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c5ceae8')) {
      api.createRecord('1c5ceae8', component.options)
    } else {
      api.reload('1c5ceae8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1c5ceae8&scoped=true&", function () {
      api.rerender('1c5ceae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/customerServer/gaoda/index.vue"
export default component.exports